import Image from 'next/image';
import Container from '../../../layout/Container';
import ComfortVideo from './ComfortVideo';

/**
 * This component renders something quite similar to the full feature wayfinder,
 * but allows a single image of a scale to be displayed on the left, and is a
 * little thinner in appearance.
 */
export default function WayfinderComfortChart({
  position,
  block,
  backgroundColor
}) {
  const { description, title, video_url, scale_image, _metadata } =
    block.comfort_chart;
  const { uid } = _metadata;

  return (
    <section
      id={`${uid}_${position}`}
      data-name="wayfinder-comfort-chart"
      className={`bg-[${backgroundColor}] py-[80px] sm:py-[60px]`}
    >
      {/* Extremely ugly string of !importants to match the live site, but
      preferable to the previous way with two nested max-w classes. Also, this
      explicitly shows what is different from the normal Container, making it
      easy to remove to just use the normal Container if approved. */}
      <Container className="max-w-[1100px]! px-0! sm:px-10! lg:px-16! 2xl:px-0!">
        <div className="items-center sm:flex sm:justify-between">
          <div className="mx-4 my-auto sm:mx-0 sm:mr-6 sm:w-1/2 lg:mr-[136px] lg:max-w-[380px]">
            <div className="relative mx-auto max-w-[379px] sm:mx-0 sm:max-w-none">
              <Image
                src={scale_image.url}
                alt={scale_image.title.replace(/\.[^/.]+$/, '')}
                width={380}
                height={41}
                sizes="380px"
              />
            </div>
            <h2
              className={'h3 lg:h2 pt-6 pb-3 text-center sm:text-left lg:pb-4'}
            >
              {title}
            </h2>
            <div
              className="body-s lg:body-r pb-6 text-center sm:pb-0 sm:text-left"
              dangerouslySetInnerHTML={{ __html: description }}
            />
          </div>
          <ComfortVideo videoUrl={video_url} />
        </div>
      </Container>
    </section>
  );
}
